import { TBreakpointProp } from './types';

export function getCSSDisplayValue(breakpoint: TBreakpointProp): string {
  return `display: ${breakpoint ? 'none' : 'contents'};`;
}
